import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://4jbhzumjk7.execute-api.us-east-2.amazonaws.com/prod';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const fileService = {
  async getFileUrl(token: string, fileKey: string): Promise<string> {
    const response = await api.get(`/files/${fileKey}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data.url;
  },
};
